import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit {
galfolder:any[];  

  constructor(private router: Router) { }

  ngOnInit(): void {
   this.galfolder=[
     {id:"1",
     foldername:"Annual Day",
     },
     {id:"2",
     foldername:"Freshers Day",
     },
     {id:"3",
     foldername:"Hostel Day",
     },
     {id:"4",
     foldername:"Send Off",
     },
     {id:"5",
     foldername:"Graduation Day",
     }
   ]
  }



  galimges(){
    this.router.navigate(['/app/galimages']);
  }

}
